import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './css/App.css';

class About extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }


  render() {
    return (
      <ul className="about clearfix">
        {this.props.home ? <li><Link to="/" className="about-red">Home</Link></li> : <li><Link to="/posts" className="about-red">All Posts</Link></li>}
        <li><Link to="/about">About</Link></li>
        <li><a href="https://deleteyourself.com" target="_blank" rel="noopener noreferrer">Delete Yourself</a></li>
      </ul>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/About.js